/**
 * RemoveAll: clear cart via POST /cart/clear.js, then refresh drawer.
 * Uses credentials, checks response, and dispatches cart:refresh so drawer updates.
 */
if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      var self = this;
      this.debouncedOnSubmit = (typeof debounce !== 'undefined' ? debounce : function(fn, wait) {
        var t;
        return function() {
          clearTimeout(t);
          t = setTimeout(fn, wait);
        };
      })(function() { self.onSubmitHandler(); }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      var self = this;
      self.classList.add('loading');

      var notesEl = document.getElementById('mini-cart__notes');
      var note = notesEl ? notesEl.value : '';

      var base = (typeof theme !== 'undefined' && theme.routes && theme.routes.cart_clear_url)
        ? theme.routes.cart_clear_url
        : (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root)
          ? window.Shopify.routes.root + 'cart/clear'
          : '/cart/clear';
      var url = base + (base.indexOf('.js') !== -1 ? '' : '.js');

      fetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ note: note })
      })
        .then(function(response) {
          self.classList.remove('loading');
          if (response.ok) {
            if (self.drawer && typeof self.drawer.refresh === 'function') {
              self.drawer.refresh();
            }
            try {
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            } catch (e) {}
          }
        })
        .catch(function() {
          self.classList.remove('loading');
        });
    }
  }
  customElements.define('remove-all', RemoveAll);
}
